<section id="app-404" #my404>
	<div class="section-main">
		<h2>4<span class="emoji" role="img" aria-label="Surprised Face With Open Mouth">😮</span>4<br />Page not Found.</h2>
		<p>Sorry, looks like this page doesn't exist... <span class="emoji" role="img" aria-label="Sad Pensive Face">😔</span></p>
		<a class="button" [href]="homeURL" [attr.data-content]="'404 Page Return Home Button'" (click)="returnHome($event)">Return Home</a>
		<div id="a404-bottom">
			<a [href]="homeURL" [attr.data-content]="'404 Page Return Home Logo'" (click)="returnHome($event)">
				<img id="a404-logo" src="./assets/images/logo-blk-001.svg" width="100" alt="404 Logo" />
				<img id="a404-logo-dm" src="./assets/images/logo-wht-001.svg" width="100" alt="404 Logo" />
			</a>
		</div>
	</div>
</section>